import { render, staticRenderFns } from "./AttributeSortFragment.vue?vue&type=template&id=15243b00&scoped=true&"
import script from "./AttributeSortFragment.vue?vue&type=script&lang=js&"
export * from "./AttributeSortFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15243b00",
  null
  
)

export default component.exports